import type { CompleteFormData } from './complete-node.types';

export const COMPLETE_FORM_ID = 'complete-node-form';

export const MAX_CTAS = 2;

/**
 * The CTA fields of a screen with no CTAs. The form's defaults fall back to these and deleting a
 * CTA resets to them, which is what leaves `isDirty` false once an author adds a CTA and deletes
 * it again: RHF compares the whole form against its defaults.
 */
export const BLANK_CTA = {
  ctaLabel: '',
  ctaUrl: '',
  ctaTarget: 'same_tab',
} as const satisfies Partial<CompleteFormData>;

export const BLANK_SECONDARY_CTA = {
  secondaryCtaLabel: '',
  secondaryCtaUrl: '',
  secondaryCtaTarget: 'same_tab',
  secondaryCtaStyle: 'secondary',
} as const satisfies Partial<CompleteFormData>;
